import React, { lazy, Suspense } from 'react';

import Modal from '../../../modal/modal';
import { ImageInterface } from '../../product-image-gallery';

import { Maybe } from '../../../../shared/types/graphql-types';

import './product-image-gallery-modal.scss';

interface ProductImageGalleryModalProps {
  image: ImageInterface | null;
  isOpen: boolean;
  onClose: () => void;
  productCode?: Maybe<string>;
  show360View?: boolean;
}

const ProductImageGallery360View = lazy(
  () =>
    import('../product-image-gallery-360-view/product-image-gallery-360-view')
);

function ProductImageGalleryModal(props: ProductImageGalleryModalProps) {
  const { image, isOpen, onClose, productCode, show360View } = props;

  return (
    <Modal isOpen={isOpen} onClose={onClose}>
      <div
        styleName={`container ${
          process.env.__FF_PDP_360_WHEEL_VIEW__ === 'true' && show360View
            ? 'container--360-view'
            : ''
        }`}
      >
        {image?.url && (
          <div>
            <img
              alt={image.altText}
              height="500"
              src={image.url}
              styleName="image"
              width="500"
            />
          </div>
        )}
        {image?.secondaryUrl && (
          <div>
            <img
              alt={image.secondaryAltText}
              height="500"
              src={image.secondaryUrl}
              styleName="image"
              width="500"
            />
          </div>
        )}
        {process.env.__FF_PDP_360_WHEEL_VIEW__ === 'true' &&
          show360View &&
          productCode && (
            <Suspense fallback={null}>
              <ProductImageGallery360View productCode={productCode} />
            </Suspense>
          )}
      </div>
    </Modal>
  );
}

export default ProductImageGalleryModal;
